/**
 * AutoMod (2026-10-29): Discord's auto moderation rules API (Manage
 * Server). Paths come from `AutoModRoutes` (packages/protocol).
 */
import {
  AutoModRoutes,
  type AutoModRule,
  type CreateAutoModRuleRequest,
  type ModifyAutoModRuleRequest,
  type Snowflake,
} from '@neosocial/protocol';
import type { ApiClient } from './client';

export function createAutoModApi(client: ApiClient) {
  return {
    rules: (g: Snowflake) => client.get<AutoModRule[]>(AutoModRoutes.rules(g)),
    create: (g: Snowflake, b: CreateAutoModRuleRequest) =>
      client.post<AutoModRule>(AutoModRoutes.rules(g), b),
    modify: (g: Snowflake, id: Snowflake, b: ModifyAutoModRuleRequest) =>
      client.patch<AutoModRule>(AutoModRoutes.rule(g, id), b),
    remove: (g: Snowflake, id: Snowflake) => client.delete<void>(AutoModRoutes.rule(g, id)),
  };
}
